import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const MarkerOutlined = forwardRef<SVGSVGElement, SvgIconProps>(
  function MarkerOutlined(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m12,21.93798c-5.4886,0 -9.93798,-4.44938 -9.93798,-9.93798c0,-5.4886 4.44938,-9.93798 9.93798,-9.93798c5.4886,0 9.93798,4.44938 9.93798,9.93798c0,5.4886 -4.44938,9.93798 -9.93798,9.93798zm-0.23672,-16.5633c-2.74254,0 -4.96889,2.1769 -4.96889,4.85853c0,1.39958 0.7442,3.02607 1.65784,4.46603c1.32636,2.09026 2.98422,3.78916 2.98422,3.78916c0.08526,0.08723 0.20385,0.13692 0.32692,0.13692c0.12309,0 0.24168,-0.04969 0.32692,-0.13692c0,0 1.65784,-1.6989 2.98422,-3.78916c0.9136,-1.43996 1.65784,-3.06635 1.65784,-4.46603c0,-2.68163 -2.22636,-4.85853 -4.96889,-4.85853l-0.0002,0l0.00002,0zm0,2.65011c1.24674,0 2.25859,0.98938 2.25859,2.20842c0,1.21905 -1.01185,2.20842 -2.25859,2.20842c-1.24674,0 -2.25859,-0.98938 -2.25859,-2.20842c0,-1.21905 1.01185,-2.20842 2.25859,-2.20842z" />
      </SvgIcon>
    )
  },
)

export default MarkerOutlined
